import { get, set, del, keys } from 'idb-keyval'
import type { PersistedClient, Persister } from '@tanstack/query-persist-client-core'
import type { GridState } from 'ag-grid-community'

const KEY = 'pipeline-cache'
const GRID_STATE_KEY = 'grid-state-pipeline'

export const pipelinePersister: Persister = {
  persistClient: (client: PersistedClient) => set(KEY, client),
  restoreClient: () => get<PersistedClient>(KEY),
  removeClient: () => del(KEY),
}

export const loadGridState = (): Promise<GridState | undefined> => get<GridState>(GRID_STATE_KEY)
export const saveGridState = (state: GridState): Promise<void> => set(GRID_STATE_KEY, state)

export async function deleteLegacyPerReqCaches(): Promise<void> {
  const all = await keys()
  for (const k of all) {
    if (typeof k === 'string' && k.startsWith(`${KEY}-`)) await del(k)
  }
}
